/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumOk: {
    name: 'big-medium-ok';
    data: string;
} = {
    name: 'big-medium-ok',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M38.55 108.32a9 9 0 0 1-6.39-2.65L4.45 77.77a5 5 0 0 1 7.1-7l27 27.18 77.9-78.43a5 5 0 1 1 7.1 7l-78.62 79.15a8.94 8.94 0 0 1-6.38 2.65"/></svg>`,
};
